import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import type { CompanyData } from '@xing-com/crate-jobs-helpers';
import { useHRContact } from '@xing-com/crate-jobs-hooks';
import { InViewTracking } from '@xing-com/crate-jobs-tracking';
import { cornerRadiusL } from '@xing-com/tokens';

import { ModuleTitle } from '../module-title';

import {
  CompanyModuleWrapper,
  StyledCompanyCard,
  StyledCompanyCardSkeleton,
  StyledHRContactCard,
  StyledHRContactCardSkeleton,
} from './company-module.styles';

const moduleHeight = '271px';

type CompanyModuleProps = {
  jobGlobalId: string;
  modulePosition: number;
  jobId: string;
  jobSlug: string;
  company?: CompanyData;
};

export const CompanyModule: React.FC<CompanyModuleProps> = ({
  jobId,
  jobSlug,
  company,
  jobGlobalId,
  modulePosition,
}) => {
  const { isLoggedIn } = useLoginState();
  const { isLoading, hrContact } = useHRContact(jobSlug, company?.id);

  if (!company) return null;

  const nwtTrackingOptions = {
    eventSchema: 'extended',
    itemUrn: jobGlobalId,
    page: 'jobs/detail',
    moduleTitle: 'about_the_company',
    modulePosition: modulePosition,
  } as const;

  return (
    <InViewTracking
      nwtTrackingOptions={{ ...nwtTrackingOptions, event: 'entered_viewport' }}
      skip={isLoggedIn}
    >
      <ModuleTitle titleKey="JOBS_JOB_DETAILS_ABOUT_COMPANY_HEADER" />
      <CompanyModuleWrapper>
        {isLoading ? (
          <StyledCompanyCardSkeleton
            height={moduleHeight}
            cornerRadius={cornerRadiusL}
          />
        ) : (
          <StyledCompanyCard
            company={company}
            isAlwaysVertical={!!hrContact}
            jobId={jobId}
          />
        )}
        {isLoading ? (
          <StyledHRContactCardSkeleton
            height={moduleHeight}
            cornerRadius={cornerRadiusL}
          />
        ) : hrContact ? (
          <StyledHRContactCard hiringContact={hrContact} jobId={jobId} />
        ) : null}
      </CompanyModuleWrapper>
    </InViewTracking>
  );
};
